/**
 * PDP Custom Variant Selector - JSON (CDN) mode
 * Builds the variant selector from collection JSON to avoid 50-product limit.
 * Same UI and behavior as Liquid: three groups, links to product URLs, full-page navigation.
 */
(function() {
  // Preserve view parameter from current URL for A/B testing
  function getViewParam() {
    var params = new URLSearchParams(window.location.search);
    return params.get('view');
  }

  function appendViewParam(url) {
    var viewParam = getViewParam();
    if (!viewParam) return url;
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'view=' + encodeURIComponent(viewParam);
  }

  function getMetafieldValue(product, metafieldPath) {
    if (!metafieldPath || !product.metafields) return '';
    
    // Special handling for tag-based values
    if (metafieldPath.startsWith('tags.')) {
      var tagType = metafieldPath.split('.')[1];
      if (tagType === 'tonnage') {
        return getTagTonnageValue(product);
      }
      return '';
    }
    
    var parts = metafieldPath.split('.');
    var value;
    if (parts.length === 2) {
      var namespace = parts[0];
      var key = parts[1];
      value = product.metafields[namespace] && product.metafields[namespace][key] && product.metafields[namespace][key].value;
    } else {
      value = product.metafields[metafieldPath] && product.metafields[metafieldPath].value;
    }
    if (typeof value === 'string' && value.indexOf('[') === 0) {
      try {
        var parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed[0] : value;
      } catch (e) {
        return value;
      }
    }
    return value != null ? String(value).trim() : '';
  }

  function normalizeValue(v) {
    return String(v || '').toLowerCase().trim();
  }

  function valuesEqual(a, b) {
    return normalizeValue(a) === normalizeValue(b);
  }

  function compareOptionValues(a, b) {
    var aStr = String(a).trim();
    var bStr = String(b).trim();
    var aNumMatch = aStr.match(/^(\d+(?:\.\d+)?)\s*[KkTt]?\s*/);
    var bNumMatch = bStr.match(/^(\d+(?:\.\d+)?)\s*[KkTt]?\s*/);
    if (aNumMatch && bNumMatch) {
      return parseFloat(aNumMatch[1]) - parseFloat(bNumMatch[1]);
    }
    var aPct = aStr.match(/^(\d+(?:\.\d+)?)\s*%/);
    var bPct = bStr.match(/^(\d+(?:\.\d+)?)\s*%/);
    if (aPct && bPct) {
      return parseFloat(aPct[1]) - parseFloat(bPct[1]);
    }
    var aNum = parseFloat(aStr);
    var bNum = parseFloat(bStr);
    if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
    var configOrder = ['upflow/horizontal', 'downflow/horizontal'];
    var aIdx = configOrder.indexOf(aStr.toLowerCase());
    var bIdx = configOrder.indexOf(bStr.toLowerCase());
    if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
    if (aIdx !== -1) return -1;
    if (bIdx !== -1) return 1;
    return aStr.localeCompare(bStr);
  }

  function escapeHtml(text) {
    if (text == null) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function getUniqueSortedValues(products, metafieldPath) {
    var seen = {};
    var values = [];
    products.forEach(function(p) {
      var v = getMetafieldValue(p, metafieldPath);
      var normalized = normalizeValue(v);
      if (v && !seen[normalized]) {
        seen[normalized] = true;
        values.push(v);
      }
    });
    values.sort(compareOptionValues);
    return values;
  }

  function findProductForValue1(products, value1, preferValue2, preferValue3, preferValue4, mf1, mf2, mf3, mf4) {
    var best = null;
    var fallback = null;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var v1 = getMetafieldValue(p, mf1);
      if (!valuesEqual(v1, value1)) continue;
      var v2 = mf2 ? getMetafieldValue(p, mf2) : '';
      var v3 = mf3 ? getMetafieldValue(p, mf3) : '';
      var v4 = mf4 ? getMetafieldValue(p, mf4) : '';
      var value4Ok = !mf4 || (preferValue4 !== undefined && valuesEqual(v4, preferValue4));
      if (preferValue2 !== undefined && valuesEqual(v2, preferValue2) && preferValue3 !== undefined && valuesEqual(v3, preferValue3) && value4Ok) {
        best = p;
        break;
      }
      if (!fallback) fallback = p;
    }
    return best || fallback;
  }

  function findProductForValue2(products, currentValue1, value2, preferValue3, preferValue4, mf1, mf2, mf3, mf4) {
    var best = null;
    var fallback = null;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var v1 = getMetafieldValue(p, mf1);
      var v2 = getMetafieldValue(p, mf2);
      if (!valuesEqual(v1, currentValue1) || !valuesEqual(v2, value2)) continue;
      var v3 = mf3 ? getMetafieldValue(p, mf3) : '';
      var v4 = mf4 ? getMetafieldValue(p, mf4) : '';
      var value4Ok = !mf4 || (preferValue4 !== undefined && valuesEqual(v4, preferValue4));
      if (preferValue3 !== undefined && valuesEqual(v3, preferValue3) && value4Ok) {
        best = p;
        break;
      }
      if (!fallback) fallback = p;
    }
    return best || fallback;
  }

  function findProductForValue3(products, currentValue1, currentValue2, value3, preferValue4, mf1, mf2, mf3, mf4) {
    var best = null;
    var fallback = null;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!valuesEqual(getMetafieldValue(p, mf1), currentValue1)) continue;
      if (mf2 && !valuesEqual(getMetafieldValue(p, mf2), currentValue2)) continue;
      if (!valuesEqual(getMetafieldValue(p, mf3), value3)) continue;
      var v4 = mf4 ? getMetafieldValue(p, mf4) : '';
      var value4Ok = !mf4 || (preferValue4 !== undefined && valuesEqual(v4, preferValue4));
      if (value4Ok) {
        best = p;
        break;
      }
      if (!fallback) fallback = p;
    }
    return best || fallback;
  }

  function findProductForValue4(products, currentValue1, currentValue2, currentValue3, value4, mf1, mf2, mf3, mf4) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!valuesEqual(getMetafieldValue(p, mf1), currentValue1)) continue;
      if (mf2 && !valuesEqual(getMetafieldValue(p, mf2), currentValue2)) continue;
      if (mf3 && !valuesEqual(getMetafieldValue(p, mf3), currentValue3)) continue;
      if (!valuesEqual(getMetafieldValue(p, mf4), value4)) continue;
      return p;
    }
    return null;
  }

  function groupModifierClass(label) {
    var labelLower = String(label || '').toLowerCase();
    if (labelLower.indexOf('configuration') !== -1) return ' custom-variant-selector__group--configuration';
    if (labelLower.indexOf('cabinet') !== -1 || labelLower.indexOf('width') !== -1) return ' custom-variant-selector__group--cabinet';
    if (labelLower.indexOf('stage') !== -1) return ' custom-variant-selector__group--stages';
    /* HVAC-073-DI */
    if (labelLower.indexOf('tonnage') !== -1) return ' custom-variant-selector__group--tonnage';
    if (labelLower.indexOf('efficiency') !== -1) return ' custom-variant-selector__group--efficiency';
    return '';
  }

  function buildGroupHtml(values, currentValue, label, findProduct, findProductArgs, valueIndex, metafieldPath) {
    if (!values.length) return '';
    valueIndex = valueIndex != null ? valueIndex : findProductArgs.length;
    var options = values.map(function(value) {
      var args = findProductArgs.slice(0, valueIndex).concat([value]).concat(findProductArgs.slice(valueIndex));
      var product = findProduct.apply(null, args);
      var isSelected = (value === currentValue);
      var displayValue = value.replace(/ BTU$/i, '');
      if (product) {
        return '<a href="' + escapeHtml(appendViewParam(product.url)) + '" class="custom-variant-selector__option' + (isSelected ? ' custom-variant-selector__option--selected' : '') + '" aria-label="Select ' + escapeHtml(value) + ' ' + escapeHtml(label).toLowerCase() + '">' + escapeHtml(displayValue) + '</a>';
      }
      return '<span class="custom-variant-selector__option custom-variant-selector__option--unavailable" aria-label="' + escapeHtml(value) + ' ' + escapeHtml(label).toLowerCase() + ' unavailable">' + escapeHtml(displayValue) + '</span>';
    });
    return '<div class="custom-variant-selector__group' + groupModifierClass(label) + '" data-metafield="' + escapeHtml(metafieldPath || '') + '" data-option-values="' + escapeHtml(values.join('|')) + '">' +
      '<div class="custom-variant-selector__heading"><span class="custom-variant-selector__label">' + escapeHtml(label) + '</span></div>' +
      '<div class="custom-variant-selector__options">' + options.join('') + '</div></div>';
  }

  function buildAndInsert(container, loader, collectionHandle, productId, mf1, mf2, mf3, mf4, label1, label2, label3, label4) {
    if (!loader.isLoaded()) return;
    window._pdpCollectionJsonLoader = loader;
    var products = loader.getProductsByHandle(collectionHandle);
    if (!products || !products.length) {
      var loadingEl = container.querySelector('.custom-variant-selector__loading');
      if (loadingEl) loadingEl.remove();
      return;
    }

    var currentProduct = null;
    for (var i = 0; i < products.length; i++) {
      if (products[i].id === productId) {
        currentProduct = products[i];
        break;
      }
    }
    if (!currentProduct) {
      var loadingEl2 = container.querySelector('.custom-variant-selector__loading');
      if (loadingEl2) loadingEl2.remove();
      return;
    }

    var sameVendorOnly = container.getAttribute('data-same-vendor-only') === 'true';
    if (sameVendorOnly && currentProduct.vendor) {
      var currentVendor = String(currentProduct.vendor).trim();
      products = products.filter(function(p) {
        return p.vendor && String(p.vendor).trim() === currentVendor;
      });
    }

    var currentValue1 = getMetafieldValue(currentProduct, mf1);
    var currentValue2 = mf2 ? getMetafieldValue(currentProduct, mf2) : '';
    var currentValue3 = mf3 ? getMetafieldValue(currentProduct, mf3) : '';
    var currentValue4 = mf4 ? getMetafieldValue(currentProduct, mf4) : '';

    var html = '';

    if (mf1 && label1) {
      var values1 = getUniqueSortedValues(products, mf1);
      html += buildGroupHtml(values1, currentValue1, label1, findProductForValue1, [products, currentValue2, currentValue3, currentValue4, mf1, mf2, mf3, mf4], 1, mf1);
    }
    if (mf2 && label2) {
      var values2 = getUniqueSortedValues(products, mf2);
      html += buildGroupHtml(values2, currentValue2, label2, findProductForValue2, [products, currentValue1, currentValue3, currentValue4, mf1, mf2, mf3, mf4], 2, mf2);
    }
    if (mf3 && label3) {
      var values3 = getUniqueSortedValues(products, mf3);
      html += buildGroupHtml(values3, currentValue3, label3, findProductForValue3, [products, currentValue1, currentValue2, currentValue4, mf1, mf2, mf3, mf4], 3, mf3);
    }
    if (mf4 && label4) {
      var values4 = getUniqueSortedValues(products, mf4);
      html += buildGroupHtml(values4, currentValue4, label4, findProductForValue4, [products, currentValue1, currentValue2, currentValue3, mf1, mf2, mf3, mf4], 4, mf4);
    }

    var loadingEl3 = container.querySelector('.custom-variant-selector__loading');
    if (loadingEl3) loadingEl3.remove();
    container.insertAdjacentHTML('beforeend', html);

    if (typeof initCustomVariantSelector === 'function') {
      container.dataset.initialized = 'false';
      initCustomVariantSelector(container);
    }
    if (typeof initPdpSelectorTooltips === 'function') {
      initPdpSelectorTooltips(container);
    }
  }

  function run() {
    var container = document.querySelector('.custom-variant-selector[data-json-mode="true"]');
    if (!container) return;

    var collectionHandle = container.getAttribute('data-collection-handle');
    var productId = parseInt(container.getAttribute('data-product-id'), 10);
    var mf1 = container.getAttribute('data-metafield-1') || '';
    var mf2 = container.getAttribute('data-metafield-2') || '';
    var mf3 = container.getAttribute('data-metafield-3') || '';
    var mf4 = container.getAttribute('data-metafield-4') || '';
    var label1 = container.getAttribute('data-label-1') || '';
    var label2 = container.getAttribute('data-label-2') || '';
    var label3 = container.getAttribute('data-label-3') || '';
    var label4 = container.getAttribute('data-label-4') || '';
    var jsonUrl = container.getAttribute('data-json-url');

    if (!collectionHandle || !jsonUrl || typeof CollectionJsonLoader === 'undefined') {
      var loading = container.querySelector('.custom-variant-selector__loading');
      if (loading) loading.remove();
      return;
    }

    var loader = window._pdpCollectionJsonLoader || new CollectionJsonLoader(jsonUrl);
    loader.load().then(function() {
      buildAndInsert(container, loader, collectionHandle, productId, mf1, mf2, mf3, mf4, label1, label2, label3, label4);
    }).catch(function(err) {
      var loadingEl4 = container.querySelector('.custom-variant-selector__loading');
      if (loadingEl4) loadingEl4.remove();
    });
  }

  function waitForLoader(callback, attempts) {
    attempts = attempts || 0;
    if (typeof CollectionJsonLoader !== 'undefined') {
      callback();
      return;
    }
    if (attempts >= 50) return;
    setTimeout(function() { waitForLoader(callback, attempts + 1); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForLoader(run);
    });
  } else {
    waitForLoader(run);
  }
})();
